export default __webpack_public_path__ + "static/media/Donating-Blood-1.193eaf40.svg";